import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=7bd2ee5d"
import script from "./UserInformation.vue?vue&type=script&lang=ts"
export * from "./UserInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports